import axios from 'axios';
const createAxios = () =>
  axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

const axiosInstance = createAxios();

export default axiosInstance;
